import { AccountCircleIcon } from './icon-def/AccountCircleIcon';
import { ArrowDownIcon } from './icon-def/ArrowDownIcon';
import { BarsLoaderIcon } from './icon-def/BarsLoaderIcon';
import { BlurbLogoIcon } from './icon-def/BlurbLogoIcon';
import { DashboardIcon } from './icon-def/DashboardIcon';
import { DotsLoaderIcon } from './icon-def/DotsLoaderIcon';
import { IndicatorIcon } from './icon-def/IndicatorIcon';
import { MarkEmailReadIcon } from './icon-def/MarkEmailReadIcon';
import { MenuIcon } from './icon-def/MenuIcon';
import { PuffLoaderIcon } from './icon-def/PuffLoaderIcon';
import { StoreIcon } from './icon-def/StoreIcon';
import { WarningIcon } from './icon-def/WarningIcon';
import React from 'react';

export interface BaseIconProps {
  /** Icon color used for custom implementation in the `svg`. */
  color?: string;
}

/** Icon functional component. */
export type Icon = React.FC<
  Omit<React.SVGProps<SVGSVGElement>, 'viewBox' | keyof BaseIconProps> &
    BaseIconProps
>;

export const Icons = {
  DotsLoader: DotsLoaderIcon,
  PuffLoader: PuffLoaderIcon,
  BarsLoader: BarsLoaderIcon,
  MarkEmailRead: MarkEmailReadIcon,
  Indicator: IndicatorIcon,
  AccountCircle: AccountCircleIcon,
  Dashboard: DashboardIcon,
  Store: StoreIcon,
  ArrowDown: ArrowDownIcon,
  BlurbLogo: BlurbLogoIcon,
  Menu: MenuIcon,
  WarningIcon: WarningIcon,
} satisfies Record<string, Icon>;

export type IconKey = keyof typeof Icons;
